import { Box, styled } from '@mui/material';

const StyledContentBody = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 3, 3),
}));

export const ContentCardBody = StyledContentBody;
